import { PrivateInterceptor } from "../../../Base/interceptors/PrivateInterceptor";


export const getMotoristas = async () => {
  const respuesta = await PrivateInterceptor(`Global/Motoristas`, "GET");
  return respuesta;
};

export const GuardarMotorista = (Datos) => {
  const respuesta = PrivateInterceptor("Global/Motoristas/GuardarMotorista", "POST", {Datos});
  return respuesta;
};

export const EditarMotorista = (Datos) => {
  const respuesta = PrivateInterceptor("Global/Motoristas/EditarMotorista", "POST", {Datos});
  return respuesta;
};